export default __webpack_public_path__ + "static/1473-2fb93677c03a1713acf15dc5789c769a.gif";